import { fieldToDisplayableName } from 'utils/formatters/fieldToDisplayableName';

import type { CreditorKeyValuePair } from 'api';

import { DetailsItem } from '@atoms/DetailsItem/DetailsItem';

type Props = {
  value: CreditorKeyValuePair[] | null;
};

export const ReceiverKeyValuePairs = ({ value }: Props) => {
  if (value) {
    return value.map((credKeyValuePair) => (
      <DetailsItem
        key={credKeyValuePair.key}
        title={fieldToDisplayableName(
          credKeyValuePair.key,
          'RECEIVER_FIELD_NAMES'
        )}
        item={credKeyValuePair.value}
        classNames="pb-2"
      />
    ));
  }
};
